export default __webpack_public_path__ + "static/media/WINSOME.c30af0b0.svg";